
















































import { Component, Inject, Vue } from "vue-property-decorator";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { deleteImages } from "@/api/delite/delite-element";
import { pics } from "@/config/host.config";

import UploadingImageToServer from "@/components/app/images/uploading-image-to-server.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: { StandartModal, UploadingImageToServer, ChangeDeliteButtons },
})
export default class HolidayLogosView extends Vue {
  @Inject({ from: "holidayLogosFolder", default: "" })
  readonly folder!: string;
  images: Array<string> = [];

  deleteLogo(id: string): void {
    deleteImages(id, this.folder).then(() => {
      this.images.splice(this.images.indexOf(id), 1);
    });
  }

  async getImages(path: string): Promise<Array<string>> {
    const uri = pics.download;
    const config: AxiosRequestConfig = {
      params: { path },
    };
    return new Promise<Array<string>>((res, rej) => {
      this.$axios
        .get(uri, config)
        .then((imgs: AxiosResponse<Array<string> | string>) => {
          if (imgs.status === 200 && imgs.data != "Папка не найдена")
            res(imgs.data as Array<string>);
        })
        .catch((e: AxiosError) => {
          rej(e);
        });
    });
  }

  createImageList(): void {
    this.getImages(this.folder).then((imgs: Array<string> | string) => {
      if (imgs != "Папка не найдена") this.images = imgs as Array<string>;
    });
  }

  mounted(): void {
    this.createImageList();
  }
}
